/**
 * TDS · UN SOLO CÓDIGO PARA EL CLIENTE.
 *
 * Shopify no deja que un mismo código rebaje el pedido y el envío salvo en
 * tiendas Plus, así que el panel emite los dos por separado: `REGALO-XXXX`
 * para el pedido y `REGALO-XXXX-E` para el envío. Pedirle al cliente que
 * teclee dos códigos es perder ventas, así que teclea UNO y esto aplica el
 * otro por detrás.
 *
 * Cómo:
 *   1. Se vigila el carrito. Cuando aparece un código aplicado que no
 *      termina en -E ni en -P, se prueban sus parejas.
 *   2. Aplicar un código es visitar /discount/CODIGO, que deja la marca en
 *      la sesión. Se hace con fetch para no sacar al cliente de la página.
 *   3. Si la pareja no existe, Shopify no la aplica y no pasa nada: el
 *      código principal sigue puesto. Por eso se puede intentar a ciegas.
 *
 * Cada código se intenta UNA vez por visita: sin eso, el carrito cambia al
 * aplicarlo, el observador se dispara otra vez y se entra en bucle.
 *
 * Esto sobra el día que la función de descuentos se pueda activar (app
 * pública o plan Plus): entonces un código hará las tres cosas de verdad,
 * también en la pantalla de pago.
 *
 * Sin console.log.
 */
(function () {
  'use strict';

  var SUFIJOS = ['-E', '-P'];          // envío y productos
  var MEMORIA = 'tds:pares-probados';
  var CONSULTA = '/apps/personaliza/lote?codigo=';
  var ESPERA = 400;

  var probados = leerProbados();
  var trabajando = false;
  var cacheCarrito = null;
  var cacheEn = 0;
  var MEMORIA_CARRITO = 2500;

  function leerProbados() {
    try {
      return JSON.parse(sessionStorage.getItem(MEMORIA) || '{}');
    } catch (e) { return {}; }
  }
  function marcarProbado(codigo) {
    probados[codigo] = 1;
    try { sessionStorage.setItem(MEMORIA, JSON.stringify(probados)); } catch (e) { /* modo privado */ }
  }

  function carrito() {
    if (cacheCarrito && Date.now() - cacheEn < MEMORIA_CARRITO) return Promise.resolve(cacheCarrito);
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { cacheCarrito = j; cacheEn = Date.now(); return j; });
  }

  /** Aplica un código sin sacar al cliente de la página. */
  function aplicar(codigo) {
    return fetch('/discount/' + encodeURIComponent(codigo), {
      credentials: 'same-origin',
      redirect: 'follow',
    }).then(function () { return true; }).catch(function () { return false; });
  }

  function revisar() {
    if (trabajando) return;
    trabajando = true;
    carrito()
      .then(function (c) {
        var aplicados = (c && c.discount_codes) || [];
        if (!aplicados.length) { trabajando = false; return; }

        var puestos = {};
        aplicados.forEach(function (d) { puestos[String(d.code).toUpperCase()] = true; });

        // El principal es el que NO es una pareja: si el cliente tecleó
        // directamente el de envío, no hay nada que completar.
        var principal = null;
        for (var i = 0; i < aplicados.length; i++) {
          var codigo = String(aplicados[i].code).toUpperCase();
          var esPareja = SUFIJOS.some(function (s) { return codigo.slice(-s.length) === s; });
          if (!esPareja) { principal = codigo; break; }
        }
        if (!principal) { trabajando = false; return; }

        // Se pregunta a la tienda QUÉ parejas existen. Probarlas a ciegas
        // dejaba un código inválido colgando en el carrito, y el cliente veía
        // un aviso de que su código no valía.
        return fetch(CONSULTA + encodeURIComponent(principal), {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        })
          .then(function (r) { return r.json(); })
          .then(function (d) { return (d && d.parejas) || []; })
          .catch(function () { return []; })
          .then(function (parejas) {
            return aplicarParejas(parejas.filter(function (par) {
              return !puestos[par] && !probados[par];
            }));
          });
      })
      .catch(function () { trabajando = false; });
  }

  function aplicarParejas(pendientes) {
        if (!pendientes.length) { trabajando = false; return; }

        // De una en una: aplicar dos a la vez hace que la segunda pise a la
        // primera en la sesión.
        var cadena = Promise.resolve();
        pendientes.forEach(function (par) {
          cadena = cadena.then(function () {
            marcarProbado(par);
            return aplicar(par).then(function () {
              cacheCarrito = null;      // el carrito ha cambiado
              return new Promise(function (r) { setTimeout(r, 300); });
            });
          });
        });

        return cadena.then(function () {
          trabajando = false;
          // Que el carrito y el cajón se enteren de la rebaja nueva.
          ['cart:refresh', 'cart:updated', 'cd:refresh'].forEach(function (ev) {
            try { document.dispatchEvent(new CustomEvent(ev, { bubbles: true })); } catch (e) { /* navegadores viejos */ }
          });
        });
  }

  var tic = null;
  function programar() {
    clearTimeout(tic);
    tic = setTimeout(revisar, ESPERA);
  }

  ['cart:refresh', 'cart:updated', 'cart:build', 'cd:open', 'cd:refresh', 'carrito-lateral:actualizado']
    .forEach(function (ev) { document.addEventListener(ev, programar, true); });

  // El cupón se mete en un formulario del carrito o del cajón: tras enviarlo,
  // el carrito trae el código nuevo.
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.querySelector && f.querySelector('[name="discount"], [name="discount_code"], [data-cd-cupon-campo]')) {
      setTimeout(programar, 900);
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', programar);
  else programar();
})();
